/* eslint-disable no-undef */
import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';
import HttpApi from 'i18next-http-backend';

/**
 * Detects the language of an rodenstock page.
 *
 * @class RodenstockLanguageDetector
 */
class RodenstockLanguageDetector {
    /**
     * Creates an instance of RodenstockLanguageDetector.
     *
     * @memberof RodenstockLanguageDetector
     */
    constructor() {
        this.lng = 'de-DE';
    }

    /**
     * Not needed but for i18next
     *
     * @memberof RodenstockLanguageDetector
     */
    init() {/* empty */}

    /**
     * Detects the language.
     *
     * @returns {String} The detected language.
     * @memberof RodenstockLanguageDetector
     */
    detect() {
        if (window.languageID) {
            let lang = window.languageID;

            // TODO: Remove this, after switching to magnolia Translation API with correct da and si language
            // if (lang === 'da') {
            //     lang = 'dk';
            // } else if (lang === 'si') {
            //     lang = 'sl';
            // } else if (lang === 'cs') {
            //     lang = 'cz';
            // } else if (lang === 'nl_be') {
            //     // For Belgium we use the Dutch language
            //     lang = 'fl';
            // }

            return lang.split('_')[0] ?? 'en';
        }

        return 'en';
    }

    /**
     * Caches the language in the instance.
     *
     * @param {String} lng Detected language.
     * @memberof RodenstockLanguageDetector
     */
    cacheUserLanguage(lng) {
        this.lng = lng;
    }
}

RodenstockLanguageDetector.type = 'languageDetector';

const load = new Promise(function(resolve) {
    i18n
        .use(HttpApi)
        .use(initReactI18next)
        .use(RodenstockLanguageDetector)
        .init({
            saveMissing: false,
            updateMissing: TRANSLATE_DEBUG,
            fallbackLng: 'en',
            debug: TRANSLATE_DEBUG,
            // lng: 'de-DE',
            backend: {

                crossDomain: true,
                // eslint-disable-next-line max-len
                loadPath: `${window.nfqRod?.contextPath ?? TRANSLATE_DEFAULT_HOST}/.rest/proptranslation/v1/translateProperty?keyPackage=rod.{{ns}}.&languages={{lng}}&siteId=${window.nfqRod?.siteID ?? 'b2c_de'}`,

                /**
                         * Parses the translation data fetched from the backend.
                         *
                         * @param {string} data The raw translation data as a JSON string.
                         *
                         * @returns {object} The parsed translation data.
                         */
                parse(data) {
                    try {
                        const parsedData = JSON.parse(data);
                        const parsed = parsedData.reduce((acc, item) => {
                            const key = item.key.replace('rod.lensConsultant.', '');
                            const value = item.translations[0]?.value;

                            if (key && value) {
                                acc[key] = value;
                            }

                            return acc;
                        }, {});

                        return parsed;
                    } catch (error) {
                        return {};
                    }
                }

            },
            ns: ['lensConsultant'],
            defaultNS: 'lensConsultant',
            saveMissingTo: 'lensConsultant',
            interpolation: {escapeValue: false},
            react: {useSuspense: false}
        }, function() {
            resolve();
        });
});

export default load;